import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { GreyBorderBlackTextButton, RedBgButton } from '../Button/Buttons';
import CloseIcon from '../Icons/CloseIcon';

const CookieConsentModal = () => {
 const [isVisible, setIsVisible] = useState(false);

 useEffect(() => {
  const consent = localStorage.getItem('cookieConsent');
  if (!consent) {
   const timer = setTimeout(() => setIsVisible(true), 2000);
   return () => clearTimeout(timer);
  }
 }, []);

 const handleAccept = () => {
  localStorage.setItem('cookieConsent', 'accepted');
  setIsVisible(false);
 };

 const handleReject = () => {
  localStorage.setItem('cookieConsent', 'rejected');
  setIsVisible(false);
 };

 const handleClose = () => {
  setIsVisible(false);
 };

 if (!isVisible) return null;

 return (
  <Wrapper>
   <Container>
    <Left>
     <Heading>We Use Cookies</Heading>
     <Text>
      By clicking “Accept All Cookies” you agree to the storing of cookies on
      your device to enhance site navigaton, analyze site usage, and assist in
      our marketing efforts.
     </Text>
    </Left>

    <Right>
     <RedBgButton onClick={handleAccept}>Accept all</RedBgButton>
     <GreyBorderBlackTextButton onClick={handleReject}>
      Reject
     </GreyBorderBlackTextButton>
    </Right>

    <CloseButton onClick={handleClose}>
     <CloseIcon />
    </CloseButton>
   </Container>
  </Wrapper>
 );
};

export default CookieConsentModal;

const Wrapper = styled.div`
 position: fixed;
 bottom: 0px;
 left: 0;
 right: 0;
 background-color: rgba(0, 0, 0, 0.05);
 padding: 16px;
 z-index: 9999;
`;

const Container = styled.div`
 position: relative;
 display: flex;
 align-items: flex-end;
 justify-content: space-between;
 background: #faf9f9ef;
 border-radius: 24px;
 padding: 25px 40px;
 max-width: 1200px;
 margin: 0 auto;
 border: 1px solid #ffa17cb6;
 gap: 24px;

 @media (max-width: 768px) {
  flex-direction: column;
  padding: 20px;
 }
`;

const Left = styled.div`
 flex: 1;
`;

const Heading = styled.h4`
 font-size: 24px;
 font-weight: 600;
 margin-bottom: 8px;

 @media (max-width: 480px) {
  font-size: 20px;
 }
`;

const Text = styled.p`
 font-size: 16px;
 line-height: 1.4;

 a {
  color: ${({ theme }) => theme.palette.redFontColor};
  text-decoration: underline;
 }

 @media (max-width: 480px) {
  font-size: 14px;
 }
`;

const Right = styled.div`
 display: flex;
 gap: 12px;

 @media (max-width: 480px) {
  flex-direction: column;
  width: 100%;
 }

 & button {
  text-align: center;
  justify-content: center;
 }
`;

const CloseButton = styled.button`
 position: absolute;
 top: 12px;
 right: 12px;
 background: transparent;
 border: none;
 cursor: pointer;
`;
